// tslint:disable:no-console
// In production, we register a service worker to serve assets from local cache.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the 'N+1' visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
    ),
);

export default function register() {
  return new Promise((resolve, reject) => {
    if (
      // process.env.NODE_ENV === 'production' &&
      'serviceWorker' in navigator
    ) {
      // The URL constructor is available in all browsers that support SW.
      const publicUrl = new URL(
        process.env.PUBLIC_URL!,
        window.location.toString(),
      );
      if (publicUrl.origin !== window.location.origin) {
        // Our service worker won't work if PUBLIC_URL is on a different origin
        // from what our page is served on. This might happen if a CDN is used to
        // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
        return;
      }

      window.addEventListener('load', () => {
        const swUrl = `${process.env.PUBLIC_URL}/just-in-admin-worker.js`;

        if (isLocalhost) {
          // This is running on localhost. Lets check if a service worker still exists or not.
          checkValidServiceWorker(swUrl);

          // Add some additional logging to localhost, pointing developers to the
          // service worker/PWA documentation.
          navigator.serviceWorker.ready.then(registration => {
            resolve(registration);
          });
        } else {
          // Is not local host. Just register service worker
          registerValidSW(swUrl)
            .then(registration => resolve(registration))
            .catch(error => reject(error));
        }
      });
    }
  });
}

async function registerValidSW(swUrl: string) {
  try {
    const registration = await navigator.serviceWorker.register(swUrl);

    registration.onupdatefound = () => {
      const installingWorker = registration.installing;

      if (installingWorker) {
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              location.reload();
            }
          }
        };
      }
    };

    return registration;
  } catch (error) {
    console.error('Error during service worker registration:', error);

    return error;
  }
}

async function checkValidServiceWorker(swUrl: string) {
  try {
    // Check if the service worker can be found. If it can't reload the page.
    const response = await fetch(swUrl);
    // Ensure service worker exists, and that we really are getting a JS file.
    if (
      response.status === 404 ||
      response.headers.get('content-type')!.indexOf('javascript') === -1
    ) {
      // No service worker found. Probably a different app. Reload the page.
      const registration = await navigator.serviceWorker.ready;

      await registration.unregister();

      window.location.reload();
    } else {
      // Service worker found. Proceed as normal.
      registerValidSW(swUrl);
    }
  } catch (error) {
    console.error(
      'No internet connection found. App is running in offline mode.',
      error,
    );
  }
}

export async function unregister() {
  if ('serviceWorker' in navigator) {
    const registration = await navigator.serviceWorker.ready;

    registration.unregister();

    return 'service worker unregistered';
  } else {
    return 'no service worker found';
  }
}



// WEBPACK FOOTER //
// ./src/registerServiceWorker.ts